import React from 'react'

const OrionPlugWhite = ({ color }) => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill={color} d="M32.5,57.5c-0.6,0-1-0.4-1-1v-5.4h-2.2c-0.6,0-1-0.4-1-1v-6.4c0-0.6,0.4-1,1-1s1,0.4,1,1v5.4h4.4v-5.4
	c0-0.6,0.4-1,1-1s1,0.4,1,1v6.4c0,0.6-0.4,1-1,1h-2.2v5.4C33.5,57.1,33.1,57.5,32.5,57.5z"/>
      <path fill={color} d="M35.7,44.7h-6.4c-5,0-9.1-4-9.1-9V22.3H18c-0.6,0-1-0.4-1-1s0.4-1,1-1h7.1V8.5c0-0.6,0.4-1,1-1s1,0.4,1,1v11.8
	h10.9V8.5c0-0.6,0.4-1,1-1s1,0.4,1,1v11.8H47c0.6,0,1,0.4,1,1s-0.4,1-1,1h-2.2v13.4c0,2.4-0.9,4.7-2.7,6.4
	C40.4,43.8,38.1,44.7,35.7,44.7z M22.2,22.3v13.4c0,3.9,3.2,7,7.1,7h6.4c1.9,0,3.7-0.7,5-2.1c1.3-1.3,2.1-3.1,2.1-4.9V22.3H22.2z"/>
    </svg>
  )
}

export default OrionPlugWhite
